import React from 'react';
import { Car } from 'lucide-react';
import './CarLoader.css';

// Loader de marca DoctorCar: el mismo ícono de auto que usa el Sidebar,
// "corriendo" sobre una línea de carretera animada.
export default function CarLoader({ label = 'Cargando…', size = 22 }) {
  return (
    <div className="car-loader">
      <div className="car-loader-track">
        <Car size={size} className="car-loader-icon" />
      </div>
      {label && <p className="car-loader-label">{label}</p>}
    </div>
  );
}
